import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import ProductDetailLink from '../../../components/ProductDetailLink';
import useProductUrl from '../../../hooks/useProductUrl';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import { isProductCanceled } from '../../../helpers/isProductCanceled';

export interface CataloguePageListContentItemCardNameProps
  extends StandardDivProps<CataloguePageListContentItemCardNameClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardNameClassKey = 'root' | 'crossedText';

const themeSettings = { name: 'CataloguePageListContentItemCardName' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardNameClassKey, {}>({
      root: {
        ...theme.typography.h6,
        textAlign: 'left',
        width: '100%',
        maxWidth: '100%',
        lineHeight: 1,
        '& > a': {
          color: theme.palette.text.primary,
          fontSize: '1rem',
          fontWeight: 700,
        },
      },
      crossedText: {
        textDecoration: 'line-through',
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardName = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardNameProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();
  const to = useProductUrl(product);

  const productIsCanceled = isProductCanceled(product.taxonomies);

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink
        className={clsx({
          [classes.crossedText]: productIsCanceled,
        })}
        to={to}
        variant='inherit'
        noWrap={false}
      >
        {t(product.name, { acceptString: true })}
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemCardName.displayName = 'CataloguePageListContentItemCardName';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardName);
